export const LOADING_PORTAL_CONFIG = "LOADING_PORTAL_CONFIG";
export const FETCH_PORTAL_CONFIG = "FETCH_PORTAL_CONFIG";
export const SET_PORTAL_CONFIG = "SET_PORTAL_CONFIG";
export const RESET_PORTAL_CONFIG = "RESET_PORTAL_CONFIG";
export const UPDATE_PORTAL_CONFIG = "UPDATE_PORTAL_CONFIG";

export const loadingPortalConfig = () => ({
  type: LOADING_PORTAL_CONFIG,
  payload: { config: {} },
});

export const setPortalConfig = (config) => ({
  type: SET_PORTAL_CONFIG,
  payload: config,
});

export const fetchPortalConfig = (portalSlug) => ({
  type: FETCH_PORTAL_CONFIG,
  payload: { portalSlug },
});

export const updatePortalConfig = (config) => ({
  type: UPDATE_PORTAL_CONFIG,
  payload: config,
});

export const resetPortalConfig = () => ({
  type: RESET_PORTAL_CONFIG,
  payload: {},
});
